import React from "react"
import { BidModel } from "../../../models/bid/BidModel"
import { Organisation } from "../../../models/organisation/Organisation"
import { colorPrimaryDark } from "../../../rsc/colors/colors"
import { QBPPriceRow } from "./QBPPriceRow"
import { isArrayNullOrEmpty } from "../../../helper/helper"
import { t } from "i18next"

type Props = {
    org: Organisation
    basePrice: BidModel
}

export function QBPPriceSection({ org, basePrice }: Props) {

    return <div style={{ display: !isArrayNullOrEmpty(org.qualityLevels) ? 'block' : 'none' }}>
        <p className='lightGreyBgColor padding10 bold font-xnormal'>{t('quality_level')}</p>
        <div className='bold' style={{ display: "flex", alignItems: "center", paddingLeft: "10px", gap: '10px', marginBottom: '10px', color: colorPrimaryDark }}>
            <div style={{ flex: 1, display: "flex" }}>
                {t('name')}
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
            {t('bonus')}
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
            {t('total')}
            </div>
            <div style={{ width: "100px" }} />
        </div>
        {org.qualityLevels.map(q => {
            return <QBPPriceRow key={q.name + org.name} quality={q} bid={basePrice} org={org} />
        })
        }
    </div>

}